export default "__VITE_ASSET__41d478e9__"